module.exports = __webpack_public_path__ + "img/fa-solid_shipping-fast.1e984a22.png";